// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🎨 NAVBAR CONTAINER (Header) */
.navbarDesktop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    /* padding-top 24px = mismo origen vertical que el profile-notifications-container
       de Oportunidades (que arranca con el padding-md=24px de su content-container).
       Así los iconos campana/perfil quedan a la MISMA altura en todas las vistas. */
    padding: 24px 30px 8px 30px;
    background: transparent !important; /* Blends with white card */
    position: relative;
}

/* Left Section (Empty spacer for now, or Search if moved here) */
.navbar-left {
    width: 33.333%;
    flex: none;
}

/* Center Section (Connect Wallet) */
.navbar-center {
    width: 33.333%;
    flex: none;
    display: flex;
    justify-content: center;
}

/* Connect Button (Warning State) */
.connect-btn {
    background-color: #f09502;
    color: white;
    font-weight: 600;
    border: none;
    border-radius: 50px; /* Rounded pill */
    padding: 10px 24px;
    display: flex;
    align-items: center;
    gap: 10px;
    box-shadow: 0 4px 10px rgba(240, 149, 2, 0.3);
    transition: transform 0.2s, box-shadow 0.2s;
}

/* Connected Address Badge */
.address-badge {
    background-color: #f09502 !important; /* Orange */
    color: white !important;
    font-weight: 600;
    border: none !important;
    border-radius: 50px !important; /* Rounded edges */
    padding: 10px 24px !important;
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    box-shadow: 0 4px 10px rgba(240, 149, 2, 0.3);
    transition: all 0.2s ease;
}

.address-badge:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(240, 149, 2, 0.4);
    color: white;
}

.status-indicator {
    width: 10px;
    height: 10px;
    background-color: white; /* White dot against orange */
    border-radius: 50%;
    display: inline-block;
}

.navbar .connect img {
    width: 24px;
    height: auto;
}

/* Right Section (Icons) */
.navbar-right {
    width: 33.333%;
    flex: none;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 15px;
}

/* Media Query para dispositivos móviles (menos de 995px) */
@media (max-width: 995px) {
    .navbar ul, 
    .navbar li, 
    .navbar li a, 
    .nabvar .login, 
    .navbar .login button {
      width: 100%;
      margin: 0 auto;
    }
  
    .navbar .login button {
      margin-bottom: 5px;
    }
  
    .navbarDesktop .navbar-text {
      margin-left: 0 !important;
    }
  
    .hiddenInfoNavbar {
      display: none;
    }
  
    .navbar {
      width: 96%;
      margin: 0 2%;
      padding: 5px;
    }
  
    .navbar .collapse:not(.show) {
      display: block !important;
    }
  
    .navbar .connect {
      width: 100%; /* Ocupar todo el ancho */
      padding-left: 0;
      margin-right: 0; /* Resetear margen derecho */
      margin-left: 0;  /* Resetear margen izquierdo */
    }
  
    .navbar .connect button {
      width: 100%; /* Ocupar todo el ancho */
    }
  }
  
  /* Media Query para dispositivos móviles (menos de 995px) */
@media (max-width: 995px) {
    .navbar ul, 
    .navbar li, 
    .navbar li a, 
    .nabvar .login, 
    .navbar .login button {
      width: 100%;
      margin: 0 auto;
    }
  
    .navbar .login button {
      margin-bottom: 5px;
    }
  
    .navbarDesktop .navbar-text {
      margin-left: 0 !important;
    }
  
    .hiddenInfoNavbar {
      display: none;
    }
  
    .navbar {
      width: 96%;
      margin: 0 2%;
      padding: 5px;
    }
  
    .navbar .collapse:not(.show) {
      display: block !important;
    }
  
    .navbar .connect {
      width: 100%; /* Ocupar todo el ancho */
      padding-left: 0;
      margin: 0 !important; /* Anula cualquier margen previo */
    }
  
    .navbar .connect button {
      width: 100%; /* Botón ocupa 100% */
    }
  }
  
  @media (min-width: 768px) and (max-width: 1366px) {
    .navbar .connect button {
      width: 100% !important;
      box-sizing: border-box !important;
    }
  }

  /* Solución específica para iPad Pro - sobrescribir todos los posibles estilos */
@media (min-width: 1024px) and (max-width: 1366px) {
    /* Resetear los estilos de Bootstrap que podrían estar interfiriendo */
    .navbar-nav {
      flex-direction: column !important;
      width: 100% !important;
    }
    
    .navbar-nav.ms-auto {
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
      display: block !important;
    }
    
    .navbar .navbar-nav .nav-item {
      width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      display: block !important;
    }
    
    /* (Removed problematic 100% block button overrides) */
    
    /* Asegurarse que el contenedor también tenga el ancho correcto */
    .container-fluid {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    
    .navbar .collapse {
      width: 100% !important;
      padding: 0 !important;
    }
  }

/* 📱 Mobile Layout (Screens < 1400px) */
@media (max-width: 1400px) {
    /* Show Navbar but modify layout. padding-top 24px para igualar el origen
       vertical de los iconos con Oportunidades en este rango también. */
    .navbarDesktop {
        display: flex !important;
        padding: 24px 18px 8px 18px !important;
        justify-content: flex-end !important;
        align-items: center;
    }

    /* Hide left spacer to free room for icons on the right */
    .navbar-left {
        display: none !important;
    }

    /* Show Right Icons on mobile/tablet, aligned to the right */
    .navbar-right,
    ::ng-deep .navbar-right,
    .navbarDesktop .navbar-right,
    app-navbar-user .navbarDesktop .navbar-right {
        display: flex !important;
        width: auto !important;
        flex: 0 0 auto;
        justify-content: flex-end;
        align-items: center;
        gap: 15px;
    }

    /* Set Center fully wide to let flex alignment work seamlessly */
    .navbar-center {
        width: 100% !important;
        justify-content: center;
        flex: none;
        display: flex;
    }

    /* Adjust button size/padding for mobile if needed */
    .connect-btn {
        width: auto;
        justify-content: center;
    }
}

/* 📱 Mobile — mismo padding que profile-notifications-container de Oportunidades */
@media (max-width: 767px) {
    .navbarDesktop {
        padding: 12px 18px 12px 18px !important;
    }
}

`, "",{"version":3,"sources":["webpack://./src/app/components/navbar-user/navbar-user.component.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX;;oFAEgF;IAChF,2BAA2B;IAC3B,kCAAkC,EAAE,2BAA2B;IAC/D,kBAAkB;AACtB;;AAEA,iEAAiE;AACjE;IACI,cAAc;IACd,UAAU;AACd;;AAEA,oCAAoC;AACpC;IACI,cAAc;IACd,UAAU;IACV,aAAa;IACb,uBAAuB;AAC3B;;AAEA,mCAAmC;AACnC;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,mBAAmB,EAAE,iBAAiB;IACtC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,6CAA6C;IAC7C,2CAA2C;AAC/C;;AAEA,4BAA4B;AAC5B;IACI,oCAAoC,EAAE,WAAW;IACjD,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;IACvB,8BAA8B,EAAE,kBAAkB;IAClD,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;IAC7C,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB,EAAE,6BAA6B;IACtD,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,0BAA0B;AAC1B;IACI,cAAc;IACd,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;AACb;;AAEA,2DAA2D;AAC3D;IACI;;;;;MAKE,WAAW;MACX,cAAc;IAChB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,UAAU;MACV,YAAY;MACZ,YAAY;IACd;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,WAAW,EAAE,yBAAyB;MACtC,eAAe;MACf,eAAe,EAAE,4BAA4B;MAC7C,cAAc,GAAG,8BAA8B;IACjD;;IAEA;MACE,WAAW,EAAE,yBAAyB;IACxC;EACF;;EAEA,2DAA2D;AAC7D;IACI;;;;;MAKE,WAAW;MACX,cAAc;IAChB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,UAAU;MACV,YAAY;MACZ,YAAY;IACd;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,WAAW,EAAE,yBAAyB;MACtC,eAAe;MACf,oBAAoB,EAAE,kCAAkC;IAC1D;;IAEA;MACE,WAAW,EAAE,qBAAqB;IACpC;EACF;;EAEA;IACE;MACE,sBAAsB;MACtB,iCAAiC;IACnC;EACF;;EAEA,gFAAgF;AAClF;IACI,sEAAsE;IACtE;MACE,iCAAiC;MACjC,sBAAsB;IACxB;;IAEA;MACE,oBAAoB;MACpB,qBAAqB;MACrB,sBAAsB;MACtB,yBAAyB;IAC3B;;IAEA;MACE,sBAAsB;MACtB,oBAAoB;MACpB,qBAAqB;MACrB,yBAAyB;IAC3B;;IAEA,sDAAsD;;IAEtD,iEAAiE;IACjE;MACE,0BAA0B;MAC1B,2BAA2B;IAC7B;;IAEA;MACE,sBAAsB;MACtB,qBAAqB;IACvB;EACF;;AAEF,wCAAwC;AACxC;IACI;wEACoE;IACpE;QACI,wBAAwB;QACxB,sCAAsC;QACtC,oCAAoC;QACpC,mBAAmB;IACvB;;IAEA,yDAAyD;IACzD;QACI,wBAAwB;IAC5B;;IAEA,4DAA4D;IAC5D;;;;QAII,wBAAwB;QACxB,sBAAsB;QACtB,cAAc;QACd,yBAAyB;QACzB,mBAAmB;QACnB,SAAS;IACb;;IAEA,gEAAgE;IAChE;QACI,sBAAsB;QACtB,uBAAuB;QACvB,UAAU;QACV,aAAa;IACjB;;IAEA,oDAAoD;IACpD;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ;;AAEA,mFAAmF;AACnF;IACI;QACI,uCAAuC;IAC3C;AACJ","sourcesContent":["/* 🎨 NAVBAR CONTAINER (Header) */\n.navbarDesktop {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    /* padding-top 24px = mismo origen vertical que el profile-notifications-container\n       de Oportunidades (que arranca con el padding-md=24px de su content-container).\n       Así los iconos campana/perfil quedan a la MISMA altura en todas las vistas. */\n    padding: 24px 30px 8px 30px;\n    background: transparent !important; /* Blends with white card */\n    position: relative;\n}\n\n/* Left Section (Empty spacer for now, or Search if moved here) */\n.navbar-left {\n    width: 33.333%;\n    flex: none;\n}\n\n/* Center Section (Connect Wallet) */\n.navbar-center {\n    width: 33.333%;\n    flex: none;\n    display: flex;\n    justify-content: center;\n}\n\n/* Connect Button (Warning State) */\n.connect-btn {\n    background-color: #f09502;\n    color: white;\n    font-weight: 600;\n    border: none;\n    border-radius: 50px; /* Rounded pill */\n    padding: 10px 24px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    box-shadow: 0 4px 10px rgba(240, 149, 2, 0.3);\n    transition: transform 0.2s, box-shadow 0.2s;\n}\n\n/* Connected Address Badge */\n.address-badge {\n    background-color: #f09502 !important; /* Orange */\n    color: white !important;\n    font-weight: 600;\n    border: none !important;\n    border-radius: 50px !important; /* Rounded edges */\n    padding: 10px 24px !important;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    text-decoration: none;\n    box-shadow: 0 4px 10px rgba(240, 149, 2, 0.3);\n    transition: all 0.2s ease;\n}\n\n.address-badge:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 14px rgba(240, 149, 2, 0.4);\n    color: white;\n}\n\n.status-indicator {\n    width: 10px;\n    height: 10px;\n    background-color: white; /* White dot against orange */\n    border-radius: 50%;\n    display: inline-block;\n}\n\n.navbar .connect img {\n    width: 24px;\n    height: auto;\n}\n\n/* Right Section (Icons) */\n.navbar-right {\n    width: 33.333%;\n    flex: none;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 15px;\n}\n\n/* Media Query para dispositivos móviles (menos de 995px) */\n@media (max-width: 995px) {\n    .navbar ul, \n    .navbar li, \n    .navbar li a, \n    .nabvar .login, \n    .navbar .login button {\n      width: 100%;\n      margin: 0 auto;\n    }\n  \n    .navbar .login button {\n      margin-bottom: 5px;\n    }\n  \n    .navbarDesktop .navbar-text {\n      margin-left: 0 !important;\n    }\n  \n    .hiddenInfoNavbar {\n      display: none;\n    }\n  \n    .navbar {\n      width: 96%;\n      margin: 0 2%;\n      padding: 5px;\n    }\n  \n    .navbar .collapse:not(.show) {\n      display: block !important;\n    }\n  \n    .navbar .connect {\n      width: 100%; /* Ocupar todo el ancho */\n      padding-left: 0;\n      margin-right: 0; /* Resetear margen derecho */\n      margin-left: 0;  /* Resetear margen izquierdo */\n    }\n  \n    .navbar .connect button {\n      width: 100%; /* Ocupar todo el ancho */\n    }\n  }\n  \n  /* Media Query para dispositivos móviles (menos de 995px) */\n@media (max-width: 995px) {\n    .navbar ul, \n    .navbar li, \n    .navbar li a, \n    .nabvar .login, \n    .navbar .login button {\n      width: 100%;\n      margin: 0 auto;\n    }\n  \n    .navbar .login button {\n      margin-bottom: 5px;\n    }\n  \n    .navbarDesktop .navbar-text {\n      margin-left: 0 !important;\n    }\n  \n    .hiddenInfoNavbar {\n      display: none;\n    }\n  \n    .navbar {\n      width: 96%;\n      margin: 0 2%;\n      padding: 5px;\n    }\n  \n    .navbar .collapse:not(.show) {\n      display: block !important;\n    }\n  \n    .navbar .connect {\n      width: 100%; /* Ocupar todo el ancho */\n      padding-left: 0;\n      margin: 0 !important; /* Anula cualquier margen previo */\n    }\n  \n    .navbar .connect button {\n      width: 100%; /* Botón ocupa 100% */\n    }\n  }\n  \n  @media (min-width: 768px) and (max-width: 1366px) {\n    .navbar .connect button {\n      width: 100% !important;\n      box-sizing: border-box !important;\n    }\n  }\n\n  /* Solución específica para iPad Pro - sobrescribir todos los posibles estilos */\n@media (min-width: 1024px) and (max-width: 1366px) {\n    /* Resetear los estilos de Bootstrap que podrían estar interfiriendo */\n    .navbar-nav {\n      flex-direction: column !important;\n      width: 100% !important;\n    }\n    \n    .navbar-nav.ms-auto {\n      margin: 0 !important;\n      padding: 0 !important;\n      width: 100% !important;\n      display: block !important;\n    }\n    \n    .navbar .navbar-nav .nav-item {\n      width: 100% !important;\n      margin: 0 !important;\n      padding: 0 !important;\n      display: block !important;\n    }\n    \n    /* (Removed problematic 100% block button overrides) */\n    \n    /* Asegurarse que el contenedor también tenga el ancho correcto */\n    .container-fluid {\n      padding-left: 0 !important;\n      padding-right: 0 !important;\n    }\n    \n    .navbar .collapse {\n      width: 100% !important;\n      padding: 0 !important;\n    }\n  }\n\n/* 📱 Mobile Layout (Screens < 1400px) */\n@media (max-width: 1400px) {\n    /* Show Navbar but modify layout. padding-top 24px para igualar el origen\n       vertical de los iconos con Oportunidades en este rango también. */\n    .navbarDesktop {\n        display: flex !important;\n        padding: 24px 18px 8px 18px !important;\n        justify-content: flex-end !important;\n        align-items: center;\n    }\n\n    /* Hide left spacer to free room for icons on the right */\n    .navbar-left {\n        display: none !important;\n    }\n\n    /* Show Right Icons on mobile/tablet, aligned to the right */\n    .navbar-right,\n    ::ng-deep .navbar-right,\n    .navbarDesktop .navbar-right,\n    app-navbar-user .navbarDesktop .navbar-right {\n        display: flex !important;\n        width: auto !important;\n        flex: 0 0 auto;\n        justify-content: flex-end;\n        align-items: center;\n        gap: 15px;\n    }\n\n    /* Set Center fully wide to let flex alignment work seamlessly */\n    .navbar-center {\n        width: 100% !important;\n        justify-content: center;\n        flex: none;\n        display: flex;\n    }\n\n    /* Adjust button size/padding for mobile if needed */\n    .connect-btn {\n        width: auto;\n        justify-content: center;\n    }\n}\n\n/* 📱 Mobile — mismo padding que profile-notifications-container de Oportunidades */\n@media (max-width: 767px) {\n    .navbarDesktop {\n        padding: 12px 18px 12px 18px !important;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
